var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNiyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4526_5290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375 0H1.625C0.727865 0 0 0.713867 0 1.59375V15.4062C0 16.2861 0.727865 17 1.625 17H11.375C12.2721 17 13 16.2861 13 15.4062V1.59375C13 0.713867 12.2721 0 11.375 0ZM4.875 1.0625H8.125C8.42292 1.0625 8.66667 1.30156 8.66667 1.59375C8.66667 1.88594 8.42292 2.125 8.125 2.125H4.875C4.57708 2.125 4.33333 1.88594 4.33333 1.59375C4.33333 1.30156 4.57708 1.0625 4.875 1.0625ZM6.5 5.3125C7.69505 5.3125 8.66667 6.26543 8.66667 7.4375C8.66667 8.60957 7.69505 9.5625 6.5 9.5625C5.30495 9.5625 4.33333 8.60957 4.33333 7.4375C4.33333 6.26543 5.30495 5.3125 6.5 5.3125ZM10.2917 13.175C10.2917 13.527 9.95313 13.8125 9.53333 13.8125H3.46667C3.04688 13.8125 2.70833 13.527 2.70833 13.175V12.5375C2.70833 11.4816 3.72734 10.625 4.98333 10.625H5.1526C5.56901 10.7943 6.02266 10.8906 6.5 10.8906C6.97734 10.8906 7.43438 10.7943 7.8474 10.625H8.01667C9.27266 10.625 10.2917 11.4816 10.2917 12.5375V13.175Z",
    fill: "#277FFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4526_5290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiyIcon);
export default __webpack_public_path__ + "static/media/niy-icon.b19e810f4d4eb86920a5c4e8ca0a681c.svg";
export { ForwardRef as ReactComponent };